import { api } from 'api/api';
import { EMobileStatus, IAppointment, IAppointmentCombinedState } from 'models';
import { all, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { appointmentService, dateService } from 'services';
import { handleSagaError } from 'store/common';
import { actionCreator } from './slice';
import { selectors } from './selectors';

export function* saga(): any {
	yield takeLatest(actionCreator.INIT_START, onInitStart);
	yield takeLatest(actionCreator.LOAD_START, onLoadStart);
	yield takeEvery(actionCreator.ACCEPT_START, onAcceptStart);
	yield takeEvery(actionCreator.ACCEPT_FOLLOWUP_START, onAcceptFollowUpStart);
}

function* onInitStart(): any {
	try {
		yield all([put(actionCreator.INIT_COMPLETED()), put(actionCreator.LOAD_START())]);
	} catch (error: any) {
		yield handleSagaError(error, [actionCreator.INIT_FAILED()]);
	}
}

function* onLoadStart(): any {
	try {
		const today: string = dateService.getToday();
		const appointments: IAppointment[] = yield api.appointments.getForHome(today);
		const appointmentStates = appointmentService.buildStateModels(appointments);
		yield put(
			actionCreator.LOAD_COMPLETED({
				appointments: appointmentStates
			})
		);
	} catch (error: any) {
		yield handleSagaError(error, [actionCreator.LOAD_FAILED()]);
	}
}

function* onAcceptFollowUpStart(action: ReturnType<typeof actionCreator.ACCEPT_FOLLOWUP_START>): any {
	try {
		const appointment: IAppointmentCombinedState = yield select(selectors.getAppointment(action.payload.id));
		yield api.followUps.updateMobileStatus(appointment.id, EMobileStatus.ACCEPTED);
		const appointmentState = appointmentService.buildStateModel({ ...appointment, mobileStatus: EMobileStatus.ACCEPTED });
		yield put(
			actionCreator.ACCEPT_FOLLOWUP_COMPLETED({
				id: action.payload.id,
				appointment: appointmentState
			})
		);
	} catch (error: any) {
		yield handleSagaError(error, [actionCreator.ACCEPT_FOLLOWUP_FAILED()]);
	}
}

function* onAcceptStart(action: ReturnType<typeof actionCreator.ACCEPT_START>): any {
	try {
		const appointment: IAppointment = yield api.appointments.updateMobileStatus({
			id: action.payload.id,
			mobileStatus: EMobileStatus.ACCEPTED
		});
		const appointmentState = appointmentService.buildStateModel(appointment);
		yield put(
			actionCreator.ACCEPT_COMPLETED({
				id: action.payload.id,
				appointment: appointmentState
			})
		);
	} catch (error: any) {
		yield handleSagaError(error, [
			actionCreator.ACCEPT_FAILED({
				id: action.payload.id
			})
		]);
	}
}
